import React, { useState, useEffect } from 'react';

// Importy zrzutów ekranu
import homeScreenshot from '../assets/home-screen.png';
import statsScreenshot from '../assets/stats-screen.png';
import settingsScreenshot from '../assets/settings-screen.png';
import funScreenshot from '../assets/fun-stats-screen.png';

const EnhancedStickyPhone = () => {
  // Stan przechowujący aktualnie aktywną sekcję
  const [activeSection, setActiveSection] = useState('hero');

  // Funkcja do obsługi scrollowania i wykrywania aktywnej sekcji
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 3; // Punkt środkowy ekranu
      const sections = document.querySelectorAll('section[id]');

      // Znajdź aktualnie widoczną sekcję
      let currentSection = 'hero';

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;

        // Sekcja jest widoczna, jeśli punkt środkowy ekranu jest w jej zakresie
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          currentSection = section.getAttribute('id');
        }
      });

      setActiveSection(currentSection);
    };

    // Dodanie nasłuchiwania na scrollowanie
    window.addEventListener('scroll', handleScroll);

    // Wywołaj handleScroll raz na początku, aby ustawić początkową sekcję
    handleScroll();

    // Usuń nasłuchiwanie przy odmontowaniu komponentu
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Wybór odpowiedniego zrzutu ekranu na podstawie aktywnej sekcji
  const getScreenshot = () => {
    switch(activeSection) {
      case 'features':
        return statsScreenshot;
      case 'settings':
        return settingsScreenshot;
      case 'fun-stats':
        return funScreenshot;
      case 'hero':
      default:
        return homeScreenshot;
    }
  };

  return (
    <div className="sticky-phone-container" style={{
      height: 'calc(100vh - 100px)', // Nieco krótsza wysokość
      display: 'flex',
      alignItems: 'center',
      position: 'sticky',
      top: '100px', // Odsunięcie od góry
      marginBottom: '20px'
    }}>
      <div
        className="phone-mockup"
        style={{
          width: '280px',
          height: '580px',
          borderRadius: '40px',
          border: '8px solid #333',
          overflow: 'hidden',
          position: 'relative',
          margin: '0 auto',
          backgroundColor: 'white',
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
          transform: 'none',
          transition: 'transform 0.3s ease'
        }}
      >
        <div
          className="screenshot"
          style={{
            height: '100%',
            width: '100%',
            backgroundImage: `url(${getScreenshot()})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transition: 'all 0.5s ease-in-out'
          }}
        />
        {/* Efekt odblasku na ekranie */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(120deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 70%)',
          pointerEvents: 'none',
          borderRadius: '32px'
        }} />
      </div>

      {/* Dodajmy wskaźnik aktywnej sekcji dla debugowania */}
      <div style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        color: '#999',
        padding: '4px 8px',
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.8)',
        display: 'none' // Ukryte w produkcji, można zmienić na 'block' do debugowania
      }}>
        Aktywna sekcja: {activeSection}
      </div>
    </div>
  );
};

export default EnhancedStickyPhone;